"use client";

import { createFileRoute } from "@tanstack/react-router";
import { Intercom } from "@/components/Intercom";

function RouteComponent() {
  return (
    <div className="flex flex-col h-[calc(100svh-3.5rem)] overflow-hidden bg-background">
      <Intercom />
    </div>
  );
}

export const Route = createFileRoute("/_authenticated/support/search/")({
  component: RouteComponent,
  staticData: { page: "support" },
});
